import script from "./conversation-thread.vue?vue&type=script&lang=ts&setup=true"
export * from "./conversation-thread.vue?vue&type=script&lang=ts&setup=true"

import "./conversation-thread.vue?vue&type=style&index=0&id=d4c749e2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4c749e2"]])

export default __exports__